import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { defaults as _defaults, kebabCase as _kebabCase } from 'lodash';
import * as tinyColor from 'tinycolor2';

export const DEFAULT_PRIMARY_COLOR: string = 'black';
export const DEFAULT_TEXT_COLOR: string = 'white';
const DEFAULT_OPACITY_HEX: string = '4C';

export type Theme = {
	headerColor: string;
	menuIconsColor: string;
	primaryColor: string;
	fadedPrimaryColor: string;
	textColor: string;
};

const defaultTheme: Theme = {
	headerColor: DEFAULT_PRIMARY_COLOR,
	menuIconsColor: DEFAULT_TEXT_COLOR,
	primaryColor: DEFAULT_PRIMARY_COLOR,
	fadedPrimaryColor: DEFAULT_PRIMARY_COLOR,
	textColor: DEFAULT_TEXT_COLOR
};

export const applyThemeToCssVariables = (theme: Theme) => {
	for (const [key, value] of Object.entries(theme)) {
		const cssVarName = '--' + _kebabCase(key);
		document.documentElement.style.setProperty(cssVarName, value);
	}
};

type Props = Partial<Theme> & {
	disableCxColorManipulation?: boolean;
};

export const getAppTheme = (props: Props): Theme => {
	const { textColor, primaryColor, disableCxColorManipulation } = props;
	let updatedTheme: Partial<Theme>;
	if (
		!disableCxColorManipulation &&
		primaryColor &&
		textColor &&
		tinyColor(primaryColor).getBrightness() > tinyColor(textColor).getBrightness()
	) {
		updatedTheme = {
			...props,
			textColor: primaryColor,
			primaryColor: textColor,
			menuIconsColor: textColor,
			fadedPrimaryColor: primaryColor + DEFAULT_OPACITY_HEX
		};
	} else {
		updatedTheme = {
			...props,
			menuIconsColor: textColor || undefined,
			fadedPrimaryColor: primaryColor + DEFAULT_OPACITY_HEX || undefined
		};
	}

	return _defaults(updatedTheme, defaultTheme);
};

export const ThemeContext = createContext<Theme>(defaultTheme);

export const useTheme = (): Theme => useContext<Theme>(ThemeContext);
